import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';

import {
  AuthToastComponent,
  GoogleAccountComponent,
  GoogleAccountAdminComponent,
  GoogleAuthLinkComponent,
  GoogleConnectionMastheadComponent,
} from '@mode/workspace-settings/feature-google';

export const DowngradedWorkspaceSettingsFeatureGoogleModule = angular
  .module('downgraded-workspace-settings-feature-google', [])
  .directive('modeAuthToast', downgradeComponent({ component: AuthToastComponent }))
  .directive('modeGoogleAccount', downgradeComponent({ component: GoogleAccountComponent }))
  .directive('modeGoogleAccountAdmin', downgradeComponent({ component: GoogleAccountAdminComponent }))
  .directive('modeGoogleAuthLink', downgradeComponent({ component: GoogleAuthLinkComponent }))
  .directive('modeGoogleConnectionMasthead', downgradeComponent({ component: GoogleConnectionMastheadComponent })).name;
